import styles from "./Partner.module.css"
import React from "react"
import Industri from "./Industri/index"
import Akademis from "./Akademis/index"

const Partner = () => {

  return (
    <>
      <div className={styles.partner}>
        <div className="container">
          <Industri />
          <Akademis />
        </div>
      </div>
    </>
  )
}

export default Partner
